import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-hubspot-chat-widget',
  templateUrl: './hubspot-chat-widget.component.html',
  styleUrls: ['./hubspot-chat-widget.component.scss']
})
export class HubspotChatWidgetComponent implements OnInit, OnDestroy {
  private scriptElement?: HTMLScriptElement;

  ngOnInit(): void {
    // Prevent duplicate loading
    if (!document.getElementById('hs-script-loader')) {
      this.scriptElement = document.createElement('script');
      this.scriptElement.src = 'https://js-na1.hs-scripts.com/47316647.js';  
      this.scriptElement.id = 'hs-script-loader';
      this.scriptElement.async = true;
      document.head.appendChild(this.scriptElement);
    }
  }

  ngOnDestroy(): void {
    // Optional: Clean up the script tag
    if (this.scriptElement) {
      document.head.removeChild(this.scriptElement);
    }

    // Remove HubSpot widget iframe and container
    const iframe = document.getElementById('hubspot-conversations-iframe');
    if (iframe?.parentNode) {
      iframe.parentNode.removeChild(iframe);
    }

    const widgetContainer = document.querySelector('[data-test-id="chat-widget-container"]');
    if (widgetContainer?.parentNode) {
      widgetContainer.parentNode.removeChild(widgetContainer);
    }
  }
}
